import { getAdpApiHeaders } from './adpDataSources.api'
import { config } from '@/config'

// ─── Types ────────────────────────────────────────────────────────────────────

export type AutoFillParams = {
  baseName: string
  tableName: string
}

export type AutoFillResponse = {
  suggestedName: string
}

type AutoFillApiResponse = {
  success: boolean
  status: number
  message?: string
  data?: AutoFillResponse
}

// ─── API function ─────────────────────────────────────────────────────────────

export async function fetchAutoFill(
  params: AutoFillParams,
  baseUrl = config.adpApiUrl
): Promise<AutoFillResponse> {
  const normalizedBase = (typeof baseUrl === 'string' ? baseUrl.trim() : String(baseUrl)).replace(/\/+$/, '')
  if (!normalizedBase) {
    throw new Error('ADP API URL is not configured')
  }

  const url = new URL(`${normalizedBase}/auto-fills`)
  url.searchParams.set('baseName', params.baseName)
  url.searchParams.set('tableName', params.tableName)

  const res = await fetch(url.toString(), {
    method: 'GET',
    headers: getAdpApiHeaders(),
  })

  if (!res.ok) {
    const json = (await res.json().catch(() => ({}))) as AutoFillApiResponse
    throw new Error(json.message || `Auto-fill request failed (${res.status})`)
  }

  const json = (await res.json().catch(() => ({}))) as AutoFillApiResponse
  if (!json.success || !json.data) {
    throw new Error(json.message || 'Invalid auto-fill response')
  }

  return json.data
}